import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Spinner, Button,
  Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://maasradarapi.stechomeyazilim.info";

const SiteSettingsList = () => {
  document.title = "Site Ayarları | Maaş Radar Admin Paneli";

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  const [editModal, setEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editValue, setEditValue] = useState("");

  function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
  }

  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/SiteSettings`, { headers: getAuthHeaders() });
      setItems(res.data.value || []);
    } catch (error) {
      console.error("Veriler alınamadı", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const showToast = (success, message) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, closeButton: true, progressBar: true };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const openEdit = (item) => {
    setEditItem(item);
    setEditValue(item.Value || "");
    setEditModal(true);
  };

  const handleSave = async () => {
    if (!editItem) return;
    setProcessing(p => ({ ...p, [editItem.Id + "save"]: true }));
    try {
      await axios.patch(`${API_BASE}/SiteSettings(${editItem.Id})`, { Value: editValue }, { headers: getAuthHeaders() });
      showToast(true, "Ayar güncellendi.");
      setEditModal(false);
      fetchItems();
    } catch (err) {
      console.error(err);
      showToast(false, "Güncelleme sırasında hata oluştu.");
    } finally {
      setProcessing(p => ({ ...p, [editItem.Id + "save"]: false }));
    }
  };

  const columns = useMemo(() => [
    { Header: "ID", accessor: "Id", width: "80px" },
    { Header: "Anahtar", accessor: "Key" },
    { Header: "Değer", accessor: "Value" },
    {
      Header: "İşlemler", accessor: "actions", disableSortBy: true,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button size="sm" color="primary" onClick={() => openEdit(row.original)}>Düzenle</Button>
        </div>
      )
    }
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Site Ayarları" breadcrumbItem="Liste" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer columns={columns} data={items} isGlobalFilter={true} isAddOptions={false} customPageSize={10} className="custom-header-css" />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={editModal} toggle={() => setEditModal(false)}>
        <ModalHeader toggle={() => setEditModal(false)}>Ayar Düzenle</ModalHeader>
        <ModalBody>
          {editItem && (
            <Form>
              <FormGroup>
                <Label>Anahtar</Label>
                <Input type="text" value={editItem.Key} disabled />
              </FormGroup>
              <FormGroup>
                <Label>Değer</Label>
                <Input type="text" value={editValue} onChange={(e) => setEditValue(e.target.value)} />
              </FormGroup>
              <Button color="primary" disabled={processing[editItem.Id + "save"]} onClick={handleSave}>
                {processing[editItem.Id + "save"] ? <Spinner size="sm" /> : "Kaydet"}
              </Button>
            </Form>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(SiteSettingsList);
